function UploadSuccess(){
    return(
        <div>
            <h1>Upload Successful</h1>
            <p>Check out your NFT</p>
        </div>
   
    )
}
export default UploadSuccess;